export default __webpack_public_path__ + "static/media/icon-ambulancia.fd483421.svg";